import React from 'react';
import { Card, CardHeader, Table, TableRow, TableHead, TableBody, TableCell, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslate } from 'react-admin';

const useStyle = makeStyles({
    root: {
        flex: 1,
	}
});

const UsersOnWatchlist = ({ value = [] }) => {
	const translate = useTranslate();
	const classes = useStyle();
	const history = useHistory();

	return (
		<Card className={classes.root}>
			<CardHeader title={translate('coreWalletAdmin.dashboard.usersOnWatchlist')} />
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Date</TableCell>
						<TableCell>E-Mail<br/>Phone</TableCell>
						<TableCell>Name</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{value.map(userOnWatchlist => (
						<TableRow key={userOnWatchlist.id} hover onClick={() => history.push('/users/' + userOnWatchlist.id)}>
							<TableCell>{new Date(userOnWatchlist.creationDateTime).toLocaleString('en-GB')}</TableCell>
							<TableCell>{userOnWatchlist.primaryEmail}<br/>{userOnWatchlist.primaryPhoneNumber}</TableCell>
							<TableCell>{userOnWatchlist.lastName}, {userOnWatchlist.firstName}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Card>
	)
};

export default UsersOnWatchlist;
